export const FORUM_SUBSCRIPTIONS_RESET_STATE = 'FORUM_SUBSCRIPTIONS_RESET_STATE';
export const FORUM_SUBSCRIPTIONS_CURRENT_ITEM = 'FORUM_SUBSCRIPTIONS_CURRENT_ITEM';

export const FORUM_SUBSCRIPTIONS_REQUEST_LOADING = 'FORUM_SUBSCRIPTIONS_REQUEST_LOADING';
export const FORUM_SUBSCRIPTIONS_REQUEST_SUCCESS = 'FORUM_SUBSCRIPTIONS_REQUEST_SUCCESS';
export const FORUM_SUBSCRIPTIONS_REQUEST_FAILED = 'FORUM_SUBSCRIPTIONS_REQUEST_FAILED';

export const FORUM_SUBSCRIPTIONS_CURRENT_ACTION = 'FORUM_SUBSCRIPTIONS_CURRENT_ACTION';
export const FORUM_SUBSCRIPTIONS_RESET_ACTION = 'FORUM_SUBSCRIPTIONS_RESET_ACTION';